import './CSS/IconTemplateStyle.css';
function IconTemplates (props) {
    return (
        <div>
        <img id={props.iconId} src={props.iconImage} alt={props.iconDescription} class="Icon"/> 
    
        <p class="iconstyle">{props.language}</p>
        </div>
    );
  }
  
  export default IconTemplates;
  